module.exports = __webpack_public_path__ + "img/symbol_1.0930160f.png";